import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../../components/Tooltip';

// Note: Used in the Comapny page and QV
const PerformanceListTooltip = ({
  list,
  children,
  title,
  className,
}) => {
  const content = (
    <div className="performance-list-tooltip__content">
      {title && <h5 className="performance-list-tooltip__title">{title}</h5>}
      <ul className="performance-list-tooltip__list">
        {list.map((item, index) => (
          <li key={index} className="performance-list-tooltip__list-item">
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <Tooltip
      content={content}
      colorVariant="light"
      overlayClassName={cx('performance-list-tooltip', className)}
    >
      {children}
    </Tooltip>
  );
};

PerformanceListTooltip.propTypes = {
  list: T.arrayOf(T.shape({
    label: T.node,
  })).isRequired,
  children: T.node.isRequired,
  title: T.string,
  className: T.string,
};

export default PerformanceListTooltip;
